import { render } from "./Registro03Usuario.vue?vue&type=template&id=8ddc1010&scoped=true"
import script from "./Registro03Usuario.vue?vue&type=script&lang=js"
export * from "./Registro03Usuario.vue?vue&type=script&lang=js"

import "@/assets/css/registro03Usuario.css?vue&type=style&index=0&id=8ddc1010&scoped=true&lang=css"
import "./Registro03Usuario.vue?vue&type=style&index=1&id=8ddc1010&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ddc1010"]])

export default __exports__